import { cn } from "../lib/cn";

const avatarPalette = [
  "bg-rose-500/15 text-rose-600 dark:text-rose-300",
  "bg-orange-500/15 text-orange-600 dark:text-orange-300",
  "bg-amber-500/15 text-amber-600 dark:text-amber-300",
  "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300",
  "bg-teal-500/15 text-teal-600 dark:text-teal-300",
  "bg-sky-500/15 text-sky-600 dark:text-sky-300",
  "bg-indigo-500/15 text-indigo-600 dark:text-indigo-300",
  "bg-violet-500/15 text-violet-600 dark:text-violet-300",
  "bg-fuchsia-500/15 text-fuchsia-600 dark:text-fuchsia-300",
];

function hashString(value: string) {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) | 0;
  }
  return Math.abs(hash);
}

function initials(label: string) {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  const first = parts.at(0);
  if (!first) return "?";
  const last = parts.at(-1);
  if (parts.length === 1 || !last) return first.slice(0, 2).toUpperCase();
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}

export function UserAvatar({ className, name, seed }: { className?: string; name: string; seed: string }) {
  const palette = avatarPalette[hashString(seed) % avatarPalette.length];
  return (
    <span className={cn("grid size-9 shrink-0 select-none place-items-center rounded-full text-xs font-semibold uppercase", palette, className)}>
      {initials(name)}
    </span>
  );
}
